import { AxiosResponse } from "axios";
import { DonateResponse } from "../models/response/DonateResponse";
import $api from "../http/index";

export default class DonateService {
    static async donate({steamID64, inputValue, isActive, lang}:any): Promise<AxiosResponse<DonateResponse>> {
        return $api.post<DonateResponse>('/donate', {steamID64, inputValue, isActive, lang});
    }
}